<template>
    <main id="page">
        <h1 class="text-center" title="Page Not Found"></h1>
        <b-container>
            <b-row class="justify-content-center">
                <b-col class="text-center">
                    <h2 class="not-found-content-header">Oops!</h2>
                    <p class="not-found-content-text">Something went wrong.<br>The page you were looking for does not exist!</p>
                </b-col>
            </b-row>
        </b-container>
        <div class="shape-area reversed cyan-inner purple-outer"></div>
    </main>
</template>

<script>
export default {

}
</script>
